import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  CreateProjectRequest,
  CreateProjectResponse,
  ProjectSettingsRequest,
  ProjectSettingsResponse,
  UpdateProjectStatusRequest,
  UpdateProjectStatusResponse,
  DeleteProjectRequest,
  DeleteProjectResponse,
  UpdateProjectCommentsRequest,
  UpdateProjectCommentsResponse,
} from "../../models/Project.model";

const API_BASE_URL = environment.apiUrl;

export const createNewProject = createAsyncThunk<
  CreateProjectResponse,
  CreateProjectRequest,
  { rejectValue: string }
>("project/createNewProject", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Project/createNewProject`, {
      // ✅ הסר רווח
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: CreateProjectResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to create new project");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});
// // קבלת רשימת תפריטwי בסיס
export const getProjectSettings = createAsyncThunk<
  ProjectSettingsResponse,
  ProjectSettingsRequest,
  { rejectValue: string }
>("project/getProjectSettings", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Project/settings`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: ProjectSettingsResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to get project settings");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});
export const updateProjectStatus = createAsyncThunk<
  UpdateProjectStatusResponse,
  UpdateProjectStatusRequest,
  { rejectValue: string }
>("project/updateProjectStatus", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Project/UpdateProjectStatus`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      return rejectWithValue(errorData?.message || `HTTP ${response.status}`);
    }

    const data: UpdateProjectStatusResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to update project status");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});

export const deleteProject = createAsyncThunk<
  DeleteProjectResponse,
  DeleteProjectRequest,
  { rejectValue: string }
>("project/deleteProject", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Project/DeleteProject`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: DeleteProjectResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to delete project");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});

export const updateProjectComments = createAsyncThunk<
  UpdateProjectCommentsResponse,
  UpdateProjectCommentsRequest,
  { rejectValue: string }
>("project/updateProjectComments", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}Project/UpdateProjectComments`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      },
    );

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: UpdateProjectCommentsResponse = await response.json();

    if (!data.success)
      return rejectWithValue(
        data.message || "Failed to update project comments",
      );
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});
